const en = {
  generic: {
    version: 'Version',
    error: 'Error',
    ups: 'Oops!',
    understand: 'Understand',
    no_options: 'No options',
    network_error: 'Network error',
    qraphql_error: 'GraphQL error',
    no: 'No',
    maybe_later: 'Maybe later',
    exit_without_saving:
      'Are you sure you want to leave without saving changes?',
    free: 'Free',
    yes: 'Yes',
    active: 'Active',
    inactive: 'Inactive',
    visible: 'Visible',
    invisible: 'Invisible',
    available: 'Available',
    unavailable: 'Unavailable',
    success_message: 'Changes have been saved',
    selected: 'selected',
    no_results: 'No results',
    reservation_created: 'Reservation has been created',
    from: 'From',
    to: 'To',
    all: 'All',
    none: 'N/A',
    no_data: 'No data',
    clear: 'Clear',
    clear_date: 'Clear date',
  },
  btn: {
    log_in: 'Log in',
    go_to_app: 'Go to application',
    create_new_password: 'Create new password',
    save: 'Save',
    confirm: 'Confirm',
    cancel: 'Cancel',
    back: 'Back',
    accept: 'Accept',
    reject: 'Reject',
    add_tenant: 'Add tenant',
    save_tenant: 'Save tenant',
    add_domain: 'Add domain',
    delete_domain: 'Delete domain',
    delete: 'Delete',
    delete_selected: 'Delete selected',
    send_message: 'Send message',
    send_again: 'Send selected again',
    exit: 'Exit',
    add_menu_item: 'Add new dish',
    more_data: 'More Data',
    edit: 'Edit',
    add_dish: 'Add dish',
    edit_dish: 'Edit dish',
    add_subscriptions_parking: 'Add subscription',
    search: 'Search',
    filtr_clear: 'Clear filter',
    clear_filters: 'Clear filters',
    expand: 'Expand',
    collapse: 'Collapse',
    backToUser: 'go back to User Details',
    add_survey: 'Add Survey',
    show_regulation: 'Show regulations',
    hide_regulation: 'Hide regulation',
    add_comment: 'Add comment',
    submit_range: 'Submit date range',
    save_changes: 'Save changes',
    logout: 'Logout',
    download_csv: 'Download CSV',
    check_again: 'Check again',
    refresh_app: 'Refresh',
    remind_later: 'Remind me later',
    close: 'Close',
  },
  form: {
    password: 'Password',
    new_password: 'New password',
    email_login: 'Email or Login',
    field_required: 'This field is required',
    select_tenant: 'Select a tenant...',
    tenant_required: 'You must select a tenant to accept',
    no_tenants: 'No tenants',
    comment: 'Optional comments for the user',
    company_name: 'Company name',
    domain_name: 'Email domain name',
    login: 'Login',
    contact_email: 'Contact Email',
    work_email: 'Work Email',
    first_name: 'First Name',
    last_name: 'Last Name',
    full_name: 'Full name',
    search: 'Search',
    send_again: 'Resend selected',
    message: 'Write a reply',
    form_error: 'Fill in required fields',
    log_comment: 'Comment',
    valid_nip: 'Enter valid NIP',
    card_number: 'Card number',
    valid_car_plate: 'Enter correct license plate number',
    valid_card_number_length:
      'The card number should have between {{min}} and {{max}} characters.',
    valid_card_number: 'The card number must not contain letters or spaces',
    valid_card_number_with_comma:
      'The card number must contain a comma or a dot',
  },
  days: {
    Monday: 'Mo',
    Tuesday: 'Tu',
    Wednesday: 'We',
    Thursday: 'Th',
    Friday: 'Fr',
    Saturday: 'Sa',
    Sunday: 'Su',
  },
  admin_menu: {
    language: 'Language',
    garden: 'Garden',
    garden_tickets: 'Garden tickets',
    gastro: 'Restaurant',
    gastro_menu: 'Menu',
    orders: 'Orders',
    orders_history: 'Order history',
    parking_areas: 'Parking',
    mobile_access: 'Mobile access card',
    parking_sold_subscription_list: 'Sold subscriptions list',
    payment_history: 'Payment history',
    parking_subscription_product_list: 'Subscriptions products list',
    parking_sold_one_time_tickets: 'Sold one time parking ticket list',
    parking_list: 'Parking list',
    parking_places: 'Parking place statuses',
    parking_place_reservations: 'Parking place reservations',
    users: 'Users',
    tenant_issues: 'Tenant status requests',
    users_list: 'Users list',
    unconfirmed_emails: 'Unconfirmed emails',
    companies_list: 'Companies',
    messages: 'Messages',
    minimize_menu: 'Minimize Menu',
    surveys: 'Surveys',
    surveys_list: 'Surveys List',
    surveys_results_list: 'Surveys Results ',
    blocking_olivka_products: 'Blocking Olivka products',
    bike_lockers: 'Bike lockers',
    lockers_list: 'Locker list',
    product_list: 'Product list',
    group_reservation_list: 'Group reservation list',
    reservation_list: 'Reservation list',
    locker_statistics: 'Statistics',
    parking_occupancy_report: 'Parking occupancy report',
    getresponse_sync: 'Synchronization',
    email_list: 'User list',
    integrations: 'Integrations',
    reservations: 'Company parking reservations',
    data: 'Data & analytics',
    occupancy_report: 'Spots by building',
    parking_pool_data: 'Parking pool data',
    hid_data: 'Mobile access product data',
    modules: 'Modules',
    company_reservations: 'Company reservations',
    badge_new: 'NEW',
    my_solvy: 'My Solvy',
    faq: 'FAQ',
  },
  login_screen: {
    my: 'My',
    remind_password: "I don't remember my password",
    kicker: 'Panel access',
    title: 'Sign in',
    subtitle: 'Use your My Olivia credentials to manage your company services.',
    hero_kicker: 'Olivia Centre',
    hero_title: 'Office manager panel',
    hero_subtitle:
      'Manage your company parking, access and users in one place.',
    feature_parking: 'Company parking and reservations',
    feature_users: 'Users and service profiles',
    feature_access: 'Mobile access card',
  },
  maintenance_screen: {
    app_name: 'Office Manager',
    title: 'Maintenance in progress',
    content:
      'We are updating the Office Manager panel. Signing in and managing parking and access cards are temporarily unavailable.',
    nothing_to_do:
      'There is nothing you need to do — the panel will come back on its own.',
    auto_check: 'We check automatically every 60 s',
    last_try: 'last attempt {{time}}',
  },
  new_version: {
    title: 'A new version of the panel is available',
    content:
      'This tab is running an older version. Refreshing will clear unsaved forms.',
    remind_hint: 'We will remind you again in {{hours}} h',
    stuck_title: 'This tab is still running the old version',
    stuck_content:
      'Refreshing did not help - the browser is serving files from its cache. Press {{shortcut}} to force a full reload.',
  },
  email_verification_page: {
    success: 'Your account is now active',
    tip: 'You can now log into the application',
    new_email_title: 'Your new email address has been confirmed',
    new_email: 'You can now log in with your new email',
  },
  recover_password_page: {
    title: 'Create a new password for your account',
    success:
      'Password was changed correctly, you can now log into the application.',
  },
  tenant_request_details: {
    title: 'Request for resident status',
    full_name: 'Name:',
    message: 'Message:',
    login: 'Login:',
    contact_email: 'Contact email:',
    company_email: 'Company email:',
    accepted: 'Accepted',
    rejected: 'Rejected',
    reply: 'Reply:',
    close_at: 'Closure date:',
    resolved_by: 'Verified by:',
  },
  user_message_details: {
    title: 'Message details',
    from: 'From:',
    email: 'Email:',
    company: 'Company:',
    date: 'Date:',
    message: 'Message:',
    success: 'Message was sent correctly',
    reply: 'Reply:',
    closeAt: 'Closure date:',
    resolved_by: 'Replied by:',
    delete_account: 'Account deletion request',
    os: 'System:',
    app: 'App version:',
    api: 'API version:',
    backend: 'Backend version:',
  },
  tenant: {
    add_new_tenant: 'Add new tenant',
    edit_tenant: 'Edit tenant',
    tenant_domains: 'Tenant domains:',
    add_domain: 'Add domain:',
    confirm_title: 'Are you sure you want to edit this tenant?',
    add_tenant_success: 'New tenant was added',
    add_domain_success: 'Domain was created',
  },
  email_verification_requests: {
    send_again: 'Send again',
    success: 'Email with verification code has been sent again',
    delete_request: 'Are you sure you want to delete this verification code?',
    delete_selected_requests:
      'Are you sure you want to delete selected verification codes?',
  },
  error: {
    no_app: 'Application not found.',
  },
  code: {
    100: 'OK',
    101: 'Email verified',
    102: 'Profile changed',
    103: 'Password changed',
    104: 'Tenant status updated',
    105: 'Email confirmed',
    106: 'User logged in',
    107: 'User registered',
    108: 'Change email address request accepted. Follow instructions from mail message.',
    109: 'Tenant status accepted',
    110: 'Tenant status rejected',
    111: 'Acceptance status changed',
    200: 'Ticket ordered',
    201: 'Ticket found',
    202: 'Ticket cancelled',
    300: 'Issue submitted',
    301: 'Issue resolved',
    400: 'Click verification link sent by email',
    998: 'Reserved - do not use',

    999: 'Error 999 occurred, please try again later',
    1000: 'Bad email address',
    1001: 'Error 1001 has occurred, please try again later',
    1002: 'Bad login or password',
    1003: 'Email not verified',
    1004: 'Error 1004 has occurred, please try again later',
    1005: 'Cannot verify email',
    1006: 'Invalid token, please login again',
    1007: 'Error 1007 occurred, please try again later',
    1008: 'Error 1008 occurred, please try again later',
    1009: 'Cannot add user',
    1010: 'Cannot verify user',
    1011: 'Date in wrong format',
    1012: 'Internal error - cannot get user info',
    1013: 'Cannot confirm tenant status',
    1014: 'Cannot update user',
    1015: 'Cannot update tenant status',
    1016: 'Cannot confirm email',
    1017: 'Login already taken',
    1018: 'Email address already registered',
    1019: 'Missing parameter: email',
    1020: 'Missing parameter: verification_code',
    1021: 'Missing parameter: password',
    1022: 'Cannot change password',
    1023: 'Unsupported email type',
    1024: 'Internal error - cannot parse template',
    1025: 'Invalid/expired verification code',
    1026: 'Bad parameter - action',
    1027: 'Unfortunately, the e-mail address provided was not found on our resident list - select option below.',
    1028: 'Insufficient privileges',
    1029: 'Cannot assign role',
    1030: 'Cannot unassign role',
    1031: 'Cannot add tenant',
    1032: 'Cannot modify tenant',
    1033: 'Cannot delete tenant',
    1034: 'Cannot create domain',
    1035: 'Cannot modify domain',
    1036: 'Cannot delete domain',
    1037: 'Cannot assign domain',
    1038: 'Cannot unassign domain',
    1039: 'Bad service name',
    1040: 'Cannot send email',
    1041: "We don't have such an account in our database",
    1042: 'Login too short',
    1043: 'Bad character in login',
    1044: 'Cannot resend verification code - email not known or code expired',
    1100: 'Required acceptances not provided',
    2000: 'No active ticket',
    2001: 'No active ticket',
    2002: 'Ticket server internal error',
    2003: 'Cannot buy ticket for past date',
    2004: 'Already have active ticket',
    2005: 'Internal error - unknown parameter for the ticket server',
    2006: 'Ticket server internal error',
    2007: 'You were close. There is no free slot for the date selected by you.',
    2008: 'Cannot order ticket',
    2009: 'Date out of range',
    2010: 'Oops ... You cannot book your ticket more than 31 days in advance.',
    2011: 'Ticket already used',
    3000: 'Unsupported issue type',
    3001: 'Unable to submit your request, please try again later',
    3002: 'Cannot get issue',
    4005: 'The place is taken outside the pool on the selected day',
    4036: 'This employee already has a pool reservation on the selected day',
    4040: 'Employee has not accepted employer data sharing',
    4041: 'The user has not consented to sharing their data with the employer',
  },
  user_details: {
    title: 'User details',
    confirm_modal_title: 'Confirm changes',
    firstName: 'First Name',
    lastName: 'Last Name',
    company: 'Company',
    user_roles: 'User roles',
    no_roles: 'No user roles',
    choose_role: 'Choose user roles',
    unconfirmed_user: '* Unconfirmed user',
    tenant_change_success: 'Tenant was assigned',
    tenant_deleted_success: 'Assigned tenant has been deleted',
    add_role: 'Role was assigned',
    delete_role: 'Role was unassigned',
    assigned_restaurants: 'Assigned restaurants',
    no_restaurants: 'No restaurants',
    choose_restaurant: 'Choose restaurant',
    add_restaurant: 'Restaurant was assigned',
    delete_restaurant: 'Restaurant was unassigned',
    switch_lock_enable: 'User unlocked',
    switch_lock_disabled: 'User blocked',
    lock: 'User lock',
    lock_success: 'User has been blocked',
    unlock_success: 'User has been unblocked',
    parking_no_plate: 'No registration numbers',
    parking_placeHolder: 'Cars plate ',
    user_parking: 'User cars plates ',
    acceptances: 'User acceptances:',
    global_searcher: 'Search more information about user:',
    add_feature: 'Feature was assigned',
    delete_feature: 'Feature was unassigned',
    user_features: 'User features',
    no_features: 'No features',
    choose_feature: 'Choose feature',
    shared_parking_enabled: 'Feature enabled',
    shared_parking_disabled: 'Feature disabled',
    share_parking_feature: 'Sharing parking places',
    access_card: 'Access card',
    access_card_change_success: 'Access card assigned',
    car_plate: 'Car plate',
    remove_card: 'Remove card',
    remove_card_confirmation:
      'Are you sure you want to remove the card assignment from the user?',
    add_card: 'Add access card',
    chose_card: 'Chose card type and enter the number',
    chose_card_type: 'Choose from the options below the card you want to add',
    enter_card_number: 'Type the card number',
    change_card_type: 'Change the card type',
    add_card_format: 'Add card format',
    eyebrow: 'Parking profile',
    tab_settings: 'Settings',
    tab_reservations: 'Reservations',
    assign_to_unlock: 'Assign to the service to unlock reservations',
    access_data: 'Access data',
    car_plates: 'Licence plates',
    car_plate_placeholder: 'e.g. GD 12345',
    no_car_plates: 'No licence plates assigned.',
    add_car_plate: 'Add plate',
    add_next_car_plate: 'Add another plate',
    remove_car_plate: 'Remove plate',
    parking_access: 'Parking access',
    service_profile: 'Service profile',
    profile_legend_open: 'See available profiles',
    profile_legend_title: 'Service profiles',
    profile_legend_intro:
      'The profile decides the reservation limits of the user in this service. Pick it before assigning to the service.',
    profile_badge_default: 'default',
    profile_badge_assigned: 'assigned',
    profile_limit_simultaneous: 'Simultaneous reservations',
    profile_limit_advance: 'Maximum booking in advance',
    profile_limit_duration: 'Maximum reservation length',
    profile_limit_users: 'Profile user limit',
    profile_limit_unlimited: 'unlimited',
    profile_users_assigned: 'users assigned',
    profile_parkings: 'Available parkings',
    reservation_parking_unknown: 'Parking not specified',
    profile_email_note: 'Custom e-mail notification content:',
    profile_no_limits: 'No limit information for this profile.',
    profile_days_short: 'days',
    reserve_on_behalf: 'Reserve on behalf',
    reserve_on_behalf_info:
      'This action sends an automatic e-mail and push notification to the user.',
    reserve: 'Reserve',
    reserve_coming_soon: 'This action will be available soon.',
    current_reservations: 'Current reservations',
    reservation_active: 'Active',
    no_active_reservations: 'No active reservations.',
    cancelled_reservations: 'Cancelled reservations',
    no_cancelled_reservations: 'No cancelled reservations.',
    cancelled_whole: 'Whole reservation',
    cancelled_whole_with_days: 'Whole reservation · {{n}} days',
    cancelled_single_day: 'For the day',
    cancelled_from_reservation: 'from reservation {{range}}',
    cancelled_same_day: 'On the reserved day',
    cancelled_at_value: 'Cancelled {{value}}',
    cancelled_by_value: 'by {{value}}',
    cancelled_time_unknown: 'No timestamp',
    cancelled_show_all: 'Show all ({{n}})',
    cancelled_show_less: 'Show less',
    save_changes: 'Save changes',
    unlock_after_assign: 'Available after assigning the user to the service.',
    default_profile_hint_single:
      'This profile will be assigned automatically when adding to the service.',
    default_profile_hint_multiple:
      'The default profile will be assigned when adding to the service — you can change it.',
    reserve_modal: {
      title: 'Reserve on behalf',
      step1_title: 'Choose reservation days',
      step1_sub: 'Select the days you want to create a reservation for.',
      mode_single: 'Single days',
      mode_range: 'Range',
      range_hint_start: 'Click the first day of the period.',
      range_hint_end:
        'Now click the last day — you can switch to the next month.',
      select_month: 'Select the whole month ({{n}})',
      unselect_month: 'Unselect this month',
      range_skipped:
        'Days unavailable in this period were skipped ({{count}}).',
      clear_all: 'Clear all',
      legend_selected: 'selected',
      legend_booked: 'already reserved',
      legend_full: 'no places',
      legend_blocked: 'unavailable',
      user_limit_reached:
        'The user reached the maximum number of reservations — another one cannot be created.',
      user_limit_reached_count_one:
        'The user reached the maximum number of reservations ({{count}}) — another one cannot be created.',
      user_limit_reached_count_other:
        'The user reached the maximum number of reservations ({{count}}) — another one cannot be created.',
      reason_already_reserved:
        'The user already has a reservation on this day.',
      reason_user_reservation_limit:
        'The user reached the maximum number of reservations.',
      reason_parking_user_limit: 'The user cap for this parking is full.',
      reason_pool_user_limit: 'The user cap for this pool is full.',
      reason_profile_user_limit: 'The user cap for this profile is full.',
      reason_pool_full: 'No free places on this day.',
      reason_beyond_max_advance: 'The day lies past the booking horizon.',
      reason_in_the_past: 'The day has already passed.',
      reason_pool_not_valid:
        'The pool, or the user membership in it, is not active.',
      reason_pass_disabled: 'The parking pass behind this pool is disabled.',
      reason_no_parking_assigned: 'The profile has no parking assigned.',
      reason_state_booked: 'The user already has a reservation on this day.',
      reason_state_blocked: 'This day is not available for booking.',
      reason_unknown: 'This day is not available for booking.',
      selected_dates: 'Selected dates',
      no_days: 'No days selected.',
      step2_title: 'Choose a place variant',
      step2_sub: 'Variants update based on the selected days.',
      single_hall: 'Full set in one hall',
      mixed_variants: 'Mixed variants',
      both_slots: 'both slots ({{days}})',
      notify_user: 'Notify the user (e-mail and push)',
      create_reservation: 'Create reservation',
      days_one: '{{count}} day',
      days_other: '{{count}} days',
      loading: 'Loading availability…',
      loading_variants: 'Loading variants…',
      no_variants: 'No available variants for the selected days.',
      no_variants_pool_full: 'No free places on the selected days.',
      select_days_first: 'Select days in the calendar first.',
      ordering_disabled:
        'Online reservations are currently disabled — availability preview only.',
      max_days_reached: 'Maximum number of days reached ({{count}}).',
      error_generic: 'Something went wrong. Please try again.',
      error_heading: 'An error occurred',
    },
    cancel_reservation_title: 'Cancel the whole reservation',
    cancel_reservation_confirm: 'Cancel reservation',
    cancel_whole: 'Cancel all',
    cancel_day: 'Cancel day',
    no_reservation_days: 'No day details for this reservation.',
    reservation_days: 'Reservation days',
    cancel_day_title: 'Cancel the selected day',
    cancel_day_confirm: 'Cancel day',
    select_all_days: 'Select all',
    unselect_all_days: 'Unselect all',
    select_days_hint:
      'Click a day to select it. Shift + click selects a range.',
    selected_days_count: 'Selected days: {{n}}',
    clear_day_selection: 'Clear',
    cancel_selected_days: 'Cancel selected ({{n}})',
    cancel_days_title: 'Cancel the selected days',
    cancel_days_done: 'Days cancelled: {{n}}.',
    show_days: 'Show days',
    hide_days: 'Hide days',
    cancel_default_comment: 'Cancelled by office manager',
    edit_reservation: 'Edit reservation data',
    reservation_data_saved: 'Reservation data saved.',
  },
  user_search: {
    garden_tickets: 'Show tickets to garden',
    user_acceptance_history: 'Show users consent history',
    parking_subcriptions: 'Show parking subscriptions / tickets',
    user_messages_new: 'Show new messages from the user',
    user_messages_closed: 'Show closed messages from user',
    no_questions: 'No inquiries',
    get_query: 'Choose your query',
  },

  table_component: {
    download_csv: 'Download CSV',
  },
  columns: {
    full_name: 'Full name',
    login: 'Login',
    main_email: 'Main email',
    work_email: 'Work email',
    card_number: 'Card number',
    unconfirmed_email: 'Unconfirmed email',
    created_at: 'Send date',
    company: 'Company',
    tenant: 'Tenant',
    domains: 'Email domains',
    roles: 'Roles',
    message: 'Message content',
    message_date: 'Message date',
    close_date: 'Closure date',
    status: 'Status',
    visit_date: 'Visit date',
    qr_code: 'QR Code',
    reply: 'Reply',
    creation_date: 'Creation date',
    dish_name: 'Dish name',
    price: 'Price',
    availability: 'Available',
    visible: 'Visible',
    diet_type: 'Diet type',
    category: 'Category',
    last_mobile_app: 'Last logged from mobile app',
    last_seen: 'Last login date',
    api_version: 'API version',
    car_plate: 'Car Plates',
    features: 'Features',
    ticket_type: 'Ticket type',
    order_id: 'Order Id',
    payment_status: 'Payment status',
    parking: 'Parking',
    valid_to: 'Valid to',
    valid_from: 'Valid from',
    reservation_status: 'Reservation status',
    subscription_status: 'Subscription status',
    feature_enabled: 'Feature enabled',
    place: 'Place',
    user_assigned: 'Assigned to service',
    profile: 'Profile',
    building: 'Building',
    parkings: 'Parkings',
    service: 'Service',
    card_and_plate: 'Data',
  },

  non_data: {
    non_data: '[non Data]',
  },
  user_details_table: {
    createdAt: 'Date of change',
    service: 'What kind of service',
    title: 'Consent title',
    required: 'Is it required?',
    current: 'Current user choice',
    content: 'The content of the consent',
    buttonBack: 'Close and back to User List',
    topic: 'User consent history:',
  },
  user_acceptances: {
    required: 'Is consent required?:',
    selected: 'Has the user selected consent?:',
    service: 'Which service is the consent for:',
    current: 'Is the consent / regulations currently in force:',
    createdAt: 'First Decision Date:',
    modifiedAt: 'Date of the last decision:',
  },
  bool: {
    yes: 'Yes',
    no: 'No',
  },
  payment_history: {
    details_title: 'Payment details',
    payment_date: 'Payment date',
    ticket_id: 'Ticket id',
    ticket_type: 'Ticket type',
    ticket_start: 'Ticket from',
    ticket_stop: 'Ticket to',
    product_name: 'Name of product',
    seller_company: 'Seller',
    seller_nip: 'Seller NIP',
    invoice: 'Invoice',
    invoice_data: 'Invoice data',
    parking_name: 'Parking name',
    fv: 'Faktura Vat',
    payment_id: 'Payment ID',
    account_firstname: 'First Name',
    account_lastname: 'Last Name',
    email: 'Email',
    nip: 'Nip',
    name: 'Company name',
    zipcode: 'Zipcode',
    street: 'Street',
    city: 'City',
    country: 'Country',
    car_plate_1: 'Car plate',
    car_plate_2: 'Car plate',
    access_card_id: 'OBC card ID',
    tenant_name: 'Tenant',
    payment_value_gross: 'Payment value gross',
    payment_history: 'Payment history',
    payment_status: 'Payment status',
    subscription: 'Subscription',
    oneTimeTicket: 'One time ticket',
    ticket_number: 'Ticket number',
    dates: 'Dates',
    car_plates: 'Car plates',
    price: 'Price',
    created_at: 'Created at',
    payment: 'Payment',
    lease_from: 'Lease from',
    lease_to: 'Lease to',
    building: 'Building',
    locker_number: 'Locker number',
    locker_payment_history: 'Locker payment history',
    parking_payment_history: 'Parking payment history',
  },
  parking_subscriptions_products_list: {
    parking_id: 'Parking ID',
    parking_name: 'Parking Name',
    product_duration: 'Product Duration',
    product_name: 'Product Name',
    product_id: 'Product ID',
    product_price: 'Product Price',
    product_valid_from: 'Product available from',
    product_valid_to: 'Product available to',
    active: 'Active',
    max_spaces_to_sell: 'Spaces to sell',
    seller_company_name: 'Seller company name',
    product_regulations: 'Product regulations',
    subscriptions_list: 'Subscriptions list',
  },
  parking_subscription_form: {
    add_title: 'Add Subscriptions',
    edit_title: 'Edit Subscriptions',
    name_and_price: 'Name and price',
    valid_from: 'Product available from:',
    duration: 'Subscription duration:',
    price: 'Subscription price:',
    price_label: 'Price',
    limit: 'Number of parking spaces for sale:',
    max_advance:
      'Maximum number of days in which a ticket can be purchased before use:',
    min_advance:
      'Minimum number of days in which a ticket can be purchased before use:',
    after_end:
      'How many days after the ticket expires, the parking space will be reserved:',
    valid_to: 'Product available until:',
    active: 'Is the product active:',
    select_parking: 'Select Parking',
    select_parking_no: 'No parking lots',
    rules: 'Regulations',
    select_no_rules: 'No Regulations',
    select_rules: 'Choose a regulations',
    company: 'A company that sells a subscription',
    select_company: 'Choose a company',
    select_company_no: 'No companies',
    add: 'Add',
    active_yes: 'Yes, the product is active',
    active_no: 'No, the product is not active',
    date: 'Choose a date',
    subscription: 'Subscription Name:',
    subscription_pl: 'Polish subscription name',
    subscription_en: 'English subscription name',
    days: 'Days',
    places: 'Lot',
    show_regulation: 'Show regulation content',
    min_advance_others:
      'Minimum number of working days in which a ticket can be purchased before use for buildings other than mine',
    sort: 'Sort',
    amano_product_no: 'Amano product number',
    value: 'Value',
    number: 'Number',
  },
  parking_list: {
    parking_list: 'Parking list',
    edition_parking: 'Edit Parking',
    name: 'Parking Name',
    limit_place: 'Parking space limit',
    places: 'Places',
    building: 'List of assigned buildings to the parking lot:',
    building_list: 'Expand the list of buildings',
    building_list_no: 'No list of buildings',
    parking_places: 'List of dedicated parking spaces',
    parking_places_select: 'Expand the list of targeted locations',
    parking_places_select_no: 'There is no list of specific places',
    remarks: 'Remarks',
    is_dedicate_places: 'There is dedicate place?',
    dedicate_places_number: 'Number of dedicated places',
    parking_building: 'Buildings assigned to the car park',
    company: 'Car park operator',
    company_email: 'Email to car park operator',
    go_to_places: 'Go to parking places',
    date: 'Date',
    capacity: 'Capacity',
    sold: 'Sold',
    used: 'Used',
    parking_occupancy_report: 'Parking occupancy report',
  },
  sold_parking_items: {
    valid_subscriptions_list: 'Valid subscriptions list',
    sold_one_time_tickets: 'Sold one time parking ticket list',
    valid_from: 'Valid from',
    valid_to: 'Valid to',
    product_name: 'Product name',
    product_id: 'Product Id',
    car_plates: 'Car plates',
    car_plate: 'Car plate',
    status: 'Subscription status',
    ticket_status: 'Status biletu',
    purchase_date: 'Purchase date',
    payment_amount: 'Payment amount',
    payment_status: 'Payment status',
    payment_id: 'OBC payment ID',
    payment_external_id: 'PayU payment ID',
    payment_created_at: 'Payment date',
    logs: 'Logs:',
    no_logs: 'No logs',
    log_message: 'Message',
    created_at: 'Created at',
    valid_to_info: 'with valid to date equal or greater than:',
    details_title: 'Subscription details',
    user: 'Buyer data',
    dates: 'Dates',
    related_tickets_and_payments: 'Related tickets and payments:',
    ticket: 'Ticket',
    place: 'Place',
    parameters: 'Parameters:',
    name: 'name',
    type: 'type',
    value: 'value',
    sync_with_amano: 'Sync with Amano',
    cancel_subscription: 'Cancel subscripion',
    sync_date_and_time: 'Sync date and time',
    subscription_cancelled: 'Subscription cancelled',
    cancel_subscription_info:
      'Are you sure you want to cancel this subscription?',
    ticket_number: 'Ticket number',
    ticket_details: 'Ticket details',
    comment: 'Comment',
    action_comment: 'Cancellation/resynchronization comment',
    reschedule_success: 'Subscription have been synchronized',
    sale_id: 'Sale ID',
    tenant: 'Tenant',
    payment_value: 'Price',
  },
  parking_subscription_status: {
    active: 'Active',
    cancelled: 'Cancelled',
    error: 'Error',
    new: 'New',
    past: 'Past',
    pending: 'Pending',
  },
  filter: {
    title: 'Advanced filtering by column',
    choose_column: 'Choose a column',
    choose_column_no: 'No column in table',
    value: 'Value',
  },
  feature: {
    gastro_mobile: 'Restaurant mobile',
    gastro_admin: 'Restaurant admin',
    parking_mobile: 'Parking mobile',
    parking_admin: 'Parking admin',
    olivia_news: 'Olivia news',
    survey_with_upsert: 'Survey with upsert',
  },
  logs: {
    logs: 'Logs:',
    no_logs: 'No logs',
    parameters: 'Parameters:',
    name: 'name',
    type: 'type',
    value: 'value',
  },
  parking_places: {
    parking_place_statuses: 'Parking places statuses',
    parking_place_reservations: 'Parking places reservations',
    level: 'Level',
    place: 'Place',
    shared: 'Shared',
    lease_term: 'Lease term',
    company: 'Company',
    tenant: 'Tenant',
    from: 'From',
    to: 'To',
    show_place_numbers: 'Show place numbers',
    available: 'Available',
    unavailable: 'Unavailable',
    reserved: 'Reserved',
    occupied: 'Occupied',
    to_rent: 'To rent',
    rented: 'Rented',
    yes: 'Yes',
    no: 'No',
    hide_numbers: 'Hide place numbers',
    show_numbers: 'Show place numbers',
    unlimited: 'unlimited',
    change_places_status: 'Change parking spaces status',
    change_status: 'Change status',
    new_status: 'New status',
    comment: 'Comment',
    change_status_button_hint: 'Select status and places from the list',
  },
  reservation_status: {
    ready_to_rent: 'For release',
    rented_overdue: 'To pass',
    rented: 'Rented',
    available: 'Available',
    broken: 'Damaged',
    reserved: 'Reserved',
    prereserved: 'Pre-reserved',
    error: 'Error',
    cancelled: 'Cancelled',
    finished: 'Finished',
  },
  payment_status: {
    completed: 'Completed',
    confirmed: 'Confirmed',
    error: 'Error',
    failed: 'Failed',
    new: 'New',
    processing: 'Processing',
    received: 'Received',
    cancelled: 'Cancelled',
  },
  parking_ticket_status: {
    new: 'New',
    reserved: 'Reserved',
    processing: 'Processing',
    paid: 'Paid',
    cancelled: 'Cancelled',
    unavailable: 'Unavailable',
    error: 'Error',
  },
  parking_pool_data: {
    loading_stats: 'Loading data…',
    amano_product_id: 'Amano product id',
    places_amount: 'Places amount',
    max_simultaneous_users: 'Max simultaneous users',
    max_continuous_days: 'Max continuous days',
    max_advanced_days: 'Max advanced days',
    max_simultaneous_reservations: 'Max simultaneous reservations',
    no_product: 'No product assigned',
    no_valid: 'No parking spaces assigned',
    no_valid_desc:
      'No parking spaces are assigned to your organization. Report the problem to the parking administrator.',
    no_parking_data: 'No parking data',
    no_parking_data_desc:
      'The parking module is not configured for this organization. Contact your system administrator to activate the service.',
    eyebrow: 'Parking · Dashboard',
    title: 'Data & analytics',
    subtitle: 'Service configuration and parking space utilization.',
    no_building: 'No building assigned',
    buildings_title: 'Places by building',
    buildings_as_of_today: 'Places as of today',
    buildings_as_of: 'Places as of {{date}}',
    buildings_planned_for: 'Reservations for {{date}}',
    used_unknown_yet:
      'Occupancy for future days is not known yet — reservations are shown instead.',
    utilization_unknown_yet: 'booked',
    col_building: 'Building',
    col_places: 'Places',
    col_reserved: 'Reserved',
    col_used: 'Occupied',
    col_free: 'Free',
    col_utilization: 'Utilization',
    buildings_shared_with: 'shared with: {{buildings}}',
    buildings_shared_footnote:
      'Parkings shared between buildings are counted in each of them, so the rows may add up to more than the places in the contract.',
    buildings_over_capacity: 'Reservations exceed the number of places.',
    no_buildings: 'No building data for the selected period.',
    period_day: 'Day',
    day_today: '· today',
    period_30: '30 days',
    period_90: '90 days',
    period_year: 'Year',
    avg_utilization_short: 'average utilization',
    product_config: 'Product configuration',
    cfg_parkings: 'Parkings',
    cfg_places_count: 'Places in total',
    cfg_max_users: 'Max. users',
    cfg_unlimited: 'unlimited',
    cfg_profiles: 'Profiles',
    profiles_title: 'Parking profiles',
    profiles_hint: 'Reservation limits depend on the user profile.',
    profile_users: 'users: {{n}}',
    no_profiles: 'No parking profiles defined.',
    kpi_avg_utilization: 'Average utilization',
    chart_usage_over_time: 'Space utilization over time',
    legend_occupancy: 'Occupancy',
    legend_reservations: 'Reservations',
    chart_parkings_title: 'Places by parking',
    places_count: 'places: {{n}}',
    other_parkings: 'Other ({{n}})',
    places: 'places',
    legend_capacity: 'Capacity',
    kpi_period_hint: 'in the selected period',
    kpi_delta_up: '+{{pp}} pp vs previous period',
    kpi_delta_down: '-{{pp}} pp vs previous period',
    kpi_delta_flat: 'no change vs previous period',
    parking_utilization: 'utilization {{pct}}%',
    total_available_today: 'Available today',
    total_available_on: 'Available on {{date}}',
    no_stats: 'No occupancy data for the selected period.',
    stats_error: 'Could not load parking occupancy data.',
    employee_usage_title: 'Usage by employee',
    employee_usage_hint:
      'Who books a spot and does not use it — data for the selected period.',
    employee_col_name: 'Employee',
    employee_col_reserved: 'Reserved',
    employee_col_used: 'Used',
    employee_col_unused: 'Unused',
    employee_col_cancelled: 'Cancelled',
    employee_col_ratio: 'Utilization',
    employee_usage_expand: 'Show all ({{n}})',
    employee_usage_collapse: 'Collapse list',
    employee_usage_empty: 'No employee reservations in the selected period.',
    employee_usage_error: 'Could not load employee usage data.',
    employee_usage_no_data: 'No employee usage data for the selected period.',
  },
  parking_pool_occupancy_report: {
    map_opened_instead:
      'The file could not be saved — the map opened in a new tab instead.',
    download_map_file: 'Download file',
    no_map: 'No map',
    no_map_hint: 'The map for this parking has not been added yet.',
    map_load_error: 'Could not load the map',
    map_load_error_hint: 'The map URL is set, but the file does not open.',
    map_zoom: 'Zoom in',
    open_in_tab: 'Open in a new tab',
    date: 'Date',
    capacity: 'Active user count',
    sold: 'Reserved',
    used: 'Used',
    max_user_count: 'Max user count',
    max_places_count: 'Places count by contract',
    places_count: 'Places count',
    eyebrow: 'Parking',
    title: 'Spots by building',
    subtitle:
      'Space availability in each building and personalized parking maps to download.',
    kpi_total_places: 'Total places',
    kpi_available_now: 'Available now',
    kpi_occupied: 'Occupied',
    availability_low: 'Low availability',
    availability_medium: 'Medium availability',
    availability_good: 'Good availability',
    available_of: '/ {{total}} available',
    map_badge: 'MAP',
    map_alt: 'Parking map',
    download_map: 'Download map',
    map_title: 'Parking map · {{name}}',
    map_subtitle: 'Personalized space map for this building.',
    download_pdf: 'Download PDF',
    map_downloaded: 'Map downloaded: {{name}}.pdf',
    no_parking_data: 'No parking data',
    no_parking_data_desc:
      'Parking occupancy data is unavailable. The parking module is not configured for this organization.',
    kpi_reserved_today: 'Reserved today',
    as_of: 'As of {{date}}',
    parkings_in_building: 'Parkings: {{names}}',
    card_used: '{{used}} of {{capacity}} taken',
    card_reserved: 'reserved: {{reserved}}',
    shared_with: 'Parking shared with: {{buildings}}',
    shared_note:
      'The numbers cover the whole parking and repeat under each of those buildings — do not add them up across cards.',
    no_building: 'No building assigned',
    no_stats: 'No occupancy data for today.',
    stats_error: 'Could not load parking occupancy data.',
  },
  parking_pool_reservations: {
    no_action_for_status:
      'A reservation with status “{{status}}” cannot be cancelled',
    scope_whole: 'Whole reservation',
    scope_whole_desc: 'Cancels the reservation with all of its days.',
    scope_days: 'Selected days',
    scope_days_desc: 'The reservation stays, only the ticked days are dropped.',
    days_loading: 'Loading reservation days…',
    days_unavailable: 'No per-day data for this reservation.',
    days_title: 'Reservation days ({{n}})',
    days_select_all: 'Select all',
    days_clear: 'Clear',
    days_all_selected_hint:
      'All days ticked — the result equals cancelling the whole reservation, but the user gets no notification.',
    confirm_whole: 'Cancel whole reservation',
    confirm_days: 'Cancel selected days ({{n}})',
    toast_days_cancelled: 'Cancelled reservation days: {{n}}',
    eyebrow: 'Parking',
    title: 'Company parking reservations',
    subtitle: 'Full reservation history including exact cancellation time.',
    search_placeholder: 'Search reservations…',
    filter_status: 'Status',
    filter_status_all: 'All statuses',
    col_parking: 'Parking',
    col_full_name: 'Full name',
    col_email: 'E-mail',
    col_card_number: 'Card no.',
    col_valid_from: 'Valid from',
    col_valid_to: 'Valid to',
    col_status: 'Status',
    col_period: 'Period',
    status_cancelled_day: 'Cancelled day',
    status_any_cancelled: 'All cancellations',
    day_of_reservation: 'from reservation {{period}}',
    days_cancelled_one: '{{count}} day cancelled',
    days_cancelled_other: '{{count}} days cancelled',
    days_cancelled_of: '{{count}} of {{total}} days cancelled',
    col_cancelled_at: 'Cancelled at',
    col_cancelled_by: 'Cancelled by',
    col_row_type: 'Type',
    row_type_reservation: 'Reservation',
    col_cancelled_day: 'Cancelled day',
    col_cancelled_same_day: 'Cancelled on the reserved day',
    col_cancelled_days: 'Cancelled days',
    pagination_reservations: '{{from}}–{{to}} of {{count}} reservations',
    col_actions: 'Actions',
    cancelled_same_day: 'on the reserved day',
    cancelled_time_unknown: 'No timestamp',
    cancel: 'Cancel',
    bulk_cancel: 'Cancel selected reservations',
    bulk_cancel_some: 'Cancel reservations in selection ({{count}})',
    bulk_cancel_none: 'Nothing in the selection can be cancelled',
    download_selected_csv: 'Download selected ({{count}})',
    cancel_reservation: 'Cancel reservation',
    reservation_of_user: 'Reservation of user',
    period: 'Period',
    notify_user: 'Notify user (e-mail and push)',
    back: 'Back',
    toast_cancelled_one:
      'Reservation cancelled · {{parking}}. E-mail and push notification sent.',
    toast_cancelled_many:
      '{{n}} reservations cancelled. E-mail and push notifications sent.',
    toast_cancelled_partial:
      '{{ok}} reservations cancelled, {{failed}} failed.',
    cancel_default_comment: 'Cancelled by office manager',
    toast_generating_csv: 'Generating CSV file… the file will be downloaded.',
    status_active: 'Active',
    status_cancelled: 'Cancelled',
    status_past: 'Finished',
    status_new: 'New',
    status_pending: 'Pending',
    status_error: 'Error',
  },
  parking_pool_users: {
    select_requires_service:
      'Bulk actions are available for users assigned to the service or having an access card and a licence plate',
    eyebrow: 'Parking',
    title: 'All users',
    subtitle: 'Manage building access, cards and parking profiles.',
    search_placeholder: 'Search by name, login or e-mail…',
    filter_profile: 'Profile',
    filter_service: 'Service',
    clear_filters: 'Clear filters ×',
    assign_profile: 'Assign profile',
    detach_service: 'Remove from service',
    assign_service: 'Assign to service',
    assign_service_count: 'Assign to service ({{n}})',
    select_profile_for_service:
      'Choose a profile for {{n}} users being assigned to the service.',
    toast_service_assigned: '{{n}} users assigned to the service.',
    toast_service_partial:
      '{{ok}} users assigned to the service, {{failed}} failed.',
    toast_service_failed: 'Failed to assign {{n}} users to the service.',
    toast_failure_reason: 'Reason: {{reason}}',
    ready_complete: 'Complete',
    ready_missing: 'Missing',
    service_all: 'All',
    service_assigned: 'Assigned',
    service_unassigned: 'Unassigned',
    profile_all: 'All',
    no_parking_data: 'No parking data',
    no_parking_data_desc:
      'The parking pool is not configured for this organization. Contact your system administrator to activate the module.',
    toast_profile_assigned: 'Profile assigned to {{n}} users.',
    toast_profile_partial:
      'Profile assigned to {{ok}} users, {{failed}} failed.',
    toast_profile_failed: 'Failed to assign the profile to {{n}} users.',
    toast_detached: '{{n}} users removed from the service.',
    toast_detached_partial: '{{ok}} users removed, {{failed}} failed.',
    toast_detached_failed: 'Failed to remove {{n}} users from the service.',
    no_profiles_available: 'No profiles available.',
    select_profile_for_users: 'Choose a profile for {{n}} selected users.',
    toast_generating_csv: 'Generating CSV file… the file will be downloaded.',
    csv_full_name: 'Full name',
    csv_login: 'Login',
    csv_work_email: 'Work e-mail',
    csv_profile: 'Profile',
    csv_service: 'Service',
  },
  hid: {
    hid_account: 'Mobile access card Account',
    mobile_access_card: 'Mobile access card',
    create_hid_account: 'Create HID account',
    delete_hid_account: 'Delete HID account',
    true: 'Yes',
    false: 'No',
    active: 'Active',
    inactive: 'Inactive',
    account_created: 'Account created. No cards assigned.',
    card_number: 'Card number',
    privileges_requested: 'Privileges requested',
    privileges_granted: 'Privileges granted',
    access_granted: 'Access granted',
    success_message: 'The account has been created',
    delete_HID_account: 'Delete HID account',
    delete_HID_card: 'Delete HID card',
    delete_card: 'Delete card',
    delete_access_card: 'Delete access card',
    awaiting_installation: 'Awaiting installation',
    invitation_code: 'Invitation code',
    device_id: 'Device ID',
    mysolvy_ticket_id: 'MySolvy ticket ID',
    mysolvy_ticket_status: 'Ticket status',
    delete_HID_cards: 'Delete selected cards',
    delete_account_confirmation:
      'Are you sure you want to delete the mobile access account of the user ',
    delete_card_confirmation:
      'Are you sure you want to remove the card with the number ',
    delete_selected_cards_confirmation: `Are you sure you want to delete the selected users' cards?`,
    no_hid_account_assigned: 'HID not configured',
    no_hid_account_assigned_desc:
      'The mobile access card module is not configured for this organization. Contact your system administrator to activate the HID service.',
    hid_account_deleted: 'HID account deleted',
    account_deletion_in_progress: 'Account deletion in progress...',
    account_under_creation: 'Account under creation',
    card_data: 'Card details:',
    card_under_creation: 'Card is being created',
    card_under_creation_desc:
      'The access card is being set up. This may take a moment — refresh the view in a few minutes.',
    card_deletion_in_progress: 'Card removal in progress...',
    card_requested: 'The card request has been sent',
    card_requested_desc:
      'The account will appear once HID confirms it. This may take a moment — refresh the view in a few minutes.',
    device: 'Device',
    card_deleted: 'Card deleted',
    create_card: 'Create card',
    card_settings: 'Card settings',
    with_parking_access:
      'Check if the user already has active access to the parking',
    max_number_of_mobile_cards: 'Maximum number of cards',
    used_cards: 'Used cards',
    deletion_requirement:
      'To remove the card, the device ID is required. Please refresh or wait for the user to open the application.',
    no_card_created: 'Card creation failed',
    no_card_created_desc:
      'Something went wrong while setting up the access card. Try again or contact your system administrator if the problem persists.',
    no_device_warning: `The card is awaiting installation on the user's phone. To install it, the user must open MyOlivia app, click on the 'Access Card' module, and follow the instructions.`,
    comment: 'Additional remarks for the submission',
    add_attachment: 'Add attachment to request',
    deletion_comment: 'Optional comment for card removal',
    deletion_selected_cards_comment: 'Optional comment',
    mysolvy_task_link: 'Link to the submission in MySolvy',
    number_of_cards: 'Number of cards',
    active_cards: 'Active cards',
    mobile_card_activity: 'Mobile card',
    card_status: 'Card status',
    parking_access: 'Parking access',
    my_solvy_task_number: '"Request number MySolvy',
    no_my_solvy_number: `MySolvy request will be created after the card is installed on the user's phone`,
    card_created: 'Created card',
    delete_cards_tip: 'Select from the list of users with active cards.',
  },
  hid_status: {
    NEW: 'Card activation',
    INVITATION_PENDING: 'User invitation',
    INVITATION_ACKNOWLEDGED: 'Card activation',
    CREDENTIAL_ISSUE_INITIATED: 'Card activation',
    ENDPOINT_ACTIVE: 'Card activation',
    CREDENTIAL_ISSUING: 'Card activation',
    CREDENTIAL_ISSUED: 'Activation of card access',
    ACTIVE: 'Card active',
    CREDENTIAL_REVOKING: 'Card removal',
    CREDENTIAL_REVOKED: 'Card removed',
    ENDPOINT_TERMINATED: 'Card removed',
    ENDPOINT_DELETE_INITIATED: 'Card removed',
    INVITATION_EXPIRED: 'Invitation expired',
    INVITATION_CANCEL_INITIATED: 'ZInvitation canceled',
    INVITATION_CANCELLED: 'Invitation canceled',
    NEW_DESC: '???',
    INVITATION_PENDING_DESC:
      'An invitation has been sent to the user to install the mobile card on their phone.',
    ACTIVE_DESC:
      'The card has been created. Access has been granted. Ready for use.',
    ENDPOINT_ACTIVE_DESC:
      'The user has accepted the invitation to install the mobile card on their phone. The user’s card activation process has been initiated.',
    CREDENTIAL_ISSUED_DESC:
      'The card data has been saved on the user’s phone. Access activation for the user is in progress.',
    CREDENTIAL_REVOKING_DESC:
      'The process of removing the user’s mobile card has been initiated.',
    CREDENTIAL_REVOKED_DESC:
      'The process of removing the user’s mobile card has been completed.',
  },
  hid_status_description: {
    NEW: '???',
    INVITATION_PENDING:
      'An invitation has been sent to the user to install the mobile card on their phone.',
    INVITATION_ACKNOWLEDGED:
      'The user has accepted the invitation to install the mobile card on their phone. The user’s card activation process has been initiated.',
    CREDENTIAL_ISSUE_INITIATED:
      'The user has accepted the invitation to install the mobile card on their phone. The user’s card activation process has been initiated.',
    ENDPOINT_ACTIVE:
      'The user has accepted the invitation to install the mobile card on their phone. The user’s card activation process has been initiated.',
    CREDENTIAL_ISSUING:
      'The user has accepted the invitation to install the mobile card on their phone. The user’s card activation process has been initiated.',
    CREDENTIAL_ISSUED:
      'The card data has been saved on the user’s phone. Access activation for the user is in progress.',
    ACTIVE:
      'The card has been created. Access has been granted. Ready for use.',
    CREDENTIAL_REVOKING:
      'The process of removing the user’s mobile card has been initiated.',
    CREDENTIAL_REVOKED:
      'The process of removing the user’s mobile card has been completed.',
    ENDPOINT_TERMINATED:
      'The process of removing the user’s mobile card has been completed.',
    ENDPOINT_DELETE_INITIATED:
      'The process of removing the user’s mobile card has been completed.',
  },
  parking_pool: {
    assign_user: 'Assign a user to a service',
    assign_user_to_profile: 'Assign a user to a profile',
    assigned_user: 'User assigned to the service',
    unassigned_user: 'Unassigned user from the service',
    no_car_plate_assigned_info: 'To assign car plates add an access card',
    no_card_assigned_info: `To activate user's ability to book parking add access card and car plate`,
    edit_car_plates: 'Edit car plates',
    unassign_user: 'Remove user from service',
    assigned_users: 'Assigned to service',
    no_users: 'No users',
    assign_profile_info:
      'To select a profile, you need to assign a user to the service first..',
    profile: 'Service profile',
    choose_profile: 'Choose profile',
    no_profile: 'No profile',
    assign_error: 'User assignment error occurred',
    unassign_error: 'Removing the user from the service failed',
    assign_profile_error: 'User profile assignment occurred',
    unassign_profile_error: 'User profile unassignment error occurred',
    unassign_modal_title: 'Remove the user from the service?',
    unassign_modal_lead:
      'The user will be removed from this service and will not be able to book places in it. Their data and licence plates are kept, and you can assign them again at any time.',
    unassign_active_reservation:
      'The user has an active parking reservation. Removing them from the service does not cancel it — cancel it first in the Reservations tab if it should be dropped.',
    unassign_with_card: 'Remove the access card as well',
    unassign_title: 'Select the remove card option to revoke it from the user.',
    unassign_card_warning:
      'If the user loses access to the card, they will not be able to use it under the current subscription.',
    assigned_service_badge: 'Assigned to service',
    unassigned_service_badge: 'Not assigned to service',
    assign_user_short: 'Assign',
    unassign_user_short: 'Remove',
    assign_to_service: 'Assign to service',
    assign_ready: 'All steps are complete — you can assign the user.',
    assign_prerequisites:
      'Add an access card and a licence plate to assign the user to the service.',
    select_profile_to_assign:
      'Select a profile to assign the user to the service.',
    no_profiles_available:
      'Create a profile in the pool to assign the user to the service.',
  },
}

export default en
